import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { Row, Col } from "react-bootstrap";
import React, { useEffect, useState, useRef } from "react";

import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import {
  PRODUCT_CONDITIONS_ENUMS,
  PRODUCT_TYPES_ENUMS,
  SET_BY_MARGIN_ENUMS,
} from "../../../system/globalEnums";
import SearchField from "../../../shared/components/searchField/SearchField";
import CustomTooltip from "../../../shared/components/toolTipComponent/CustomTooltip";
import DataTableComponent from "../../../shared/components/table/ReactDataTableComponent";
import InputNumberField from "../../../shared/components/inputNumberField/InputNumberField";
import TableCustomAppliesToField from "../../../shared/components/table/TableCustomAppliesToField";
import TableCustomPriceRangeField from "../../../shared/components/table/TableCustomPriceRangeField";

import { tradeInDiscountActions } from "../../../redux/actions";

import {
  toastType,
  MARGIN_TYPES,
  toastMessages,
  buttonNameConstants,
  buttonTypeConstants,
  tradeInDiscountConstant,
  SET_BY_TRADE_IN_MARGIN_OPTIONS,
  inventoryConstants,
  toggleSwitchButtonConstants,
  tradeInDiscount,
  EMPTY_STRING,
  TABLE_IDS,
} from "../../../constants";
import {
  AddIcon,
  EditIcon,
  CrossIcon,
  DeleteIcon,
  DollarIcon,
  SearchIcon,
  BlueBoxIcon,
  PercentageIcon,
  ActionDotsIcons,
} from "../../../assets/icons/iconsProvider";
import {
  tradeInsGlobalValidationSchema,
  tradeInsMonthlyValidationSchema,
} from "../../../shared/validationSchema/validationSchema";
import {
  customToast,
  filterApplyToSearchOptions,
  handleMapSelectedOptionsInEdit,
  handleCategorySelect,
  isSpinnerEnabled,
  handleSetByChange,
  getProductMargnColumns,
  getTypeCategoryColumns,
  getActionColumnOfReactDataTableComponent,
  getGroupArrayDisplayText,
} from "../../../shared/utility";
import AddTradeInMargin from "./AddTradeInMargin/AddTradeInMargin";
import SwitchButton from "../../../shared/components/SwitchButton/SwitchButton";
import { TableCustomCellWrapper } from "../../../shared/components";
const defaultGridState = {
  pageSize: 50,
  pageIndex: 0,
  sortBy: [],
};

//-------TradeIns component start here
const TradeIns = (props) => {
  const {
    inventory,
    currentStore,
    spinnerArray,
    tradeinMargin,
    addGlobalMargin,
    addMonthlyBudget,
    itemOrganization,
    addCategoryMargin,
    updateCategoryMargin,
    deleteCategoryMargin,
  } = props;

  //-----reducer
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  const { productTags } = inventory;

  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [setByFilter, setSetByFilter] = useState("");
  const [editCategory, setEditCategory] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [itemMarginUnit, setItemMarginUnit] = useState(false);
  const [searchCategories, setSearchCategories] = useState([]);
  const [gridState, setGridState] = useState(defaultGridState);
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [filterProductType, setFilterProductType] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [modalCheckBoxStatus, setModalCheckBoxStatus] = useState(false);
  const [filterProductCategory, setFilterProductCategory] = useState("");
  const [resetSearchCategories, setResetSearchCategories] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(
    inventoryConstants.VIDEO_GAME_CONDITION[0]
  );
  const [defaultCategorySortFieldId, setDefaultCategorySortFieldId] =
    useState();
  let numOfRenders = useRef(0);
  const initialGlobalValues = {
    cashMargin:
      tradeinMargin?.globalMargin?.cashMarginPercentage || EMPTY_STRING,
    tradeMargin:
      tradeinMargin?.globalMargin?.tradeinMarginPercentage || EMPTY_STRING,
  };

  const [updatedRowsData, setupdatedRowsData] = useState([]);

  const initialValues = {
    budget: currentStore?.budget || EMPTY_STRING,
    alwaysUseStockPriceForCogs:
      currentStore?.[
        toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
      ] || false,
  };
  const handleSwitchChange = (id, checkboxStatus) => {
    setModalCheckBoxStatus(checkboxStatus);
  };

  const handleSetByMarginChange = (option) => {
    handleSetByChange(
      option,
      customTypes,
      setSetByFilter,
      setSelectedTags,
      customCategories,
      filterProductType,
      setItemMarginUnit,
      selectedCategories,
      setSearchCategories,
      customSubCategories,
      setSelectedCondition,
      setSelectedCategories,
      filterProductCategory,
      setModalCheckBoxStatus
    );
  };

  const productConditionList = [
    ...inventoryConstants.VIDEO_GAME_CONDITION,
    {
      value: PRODUCT_CONDITIONS_ENUMS.USED,
      label: PRODUCT_CONDITIONS_ENUMS.USED,
    },
  ];

  //-------Handle TradeIns edit click
  const handleEditClick = (row) => {
    const marginType = row.marginType;

    setIsEdit(true);
    setEditCategory({
      ...row,
      setBy:
        marginType === SET_BY_MARGIN_ENUMS.CATEGORY.value
          ? SET_BY_MARGIN_ENUMS.CATEGORY.value
          : marginType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
          ? SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
          : marginType === SET_BY_MARGIN_ENUMS.PRODUCT.value
          ? SET_BY_MARGIN_ENUMS.PRODUCT.value
          : SET_BY_MARGIN_ENUMS.TYPE.value,
    });
    handleSetByMarginChange(
      marginType === SET_BY_MARGIN_ENUMS.CATEGORY.value
        ? SET_BY_MARGIN_ENUMS.CATEGORY.value
        : marginType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
        ? SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
        : marginType === SET_BY_MARGIN_ENUMS.PRODUCT.value
        ? SET_BY_MARGIN_ENUMS.PRODUCT.value
        : SET_BY_MARGIN_ENUMS.TYPE.value
    );
    toggleCustomTradeModal();
    setSelectedCategories(
      handleMapSelectedOptionsInEdit(row.marginGroup, marginType)
    );

    setSelectedCondition(
      marginType === SET_BY_MARGIN_ENUMS.PRODUCT.value
        ? productConditionList.find(
            (condition) => condition.value === row.productCondition
          )
        : productConditionList[0]
    );

    setSelectedTags(
      marginType === SET_BY_MARGIN_ENUMS.PRODUCT.value ? row.tags : []
    );

    setItemMarginUnit(
      row.productMarginSetBy === tradeInDiscountConstant.FIXED_VALUE
        ? true
        : false
    );

    if (row.minPriceRange >= 0 && row.maxPriceRange >= 0) {
      setModalCheckBoxStatus(true);
    }
    const filterCategory = filterApplyToSearchOptions(
      marginType,
      customTypes.filter(
        (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
      ),
      customCategories,
      customSubCategories,
      filterProductType,
      filterProductCategory,
      selectedCategories
    );

    const categoriesNames = row.marginGroup.map((row) => {
      return marginType === SET_BY_MARGIN_ENUMS.CATEGORY.value
        ? row.categoryName
        : marginType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
        ? row.subcategoryName
        : row.productType;
    });

    setSearchCategories(
      filterCategory.filter((category) => {
        return !categoriesNames.includes(category.name);
      })
    );
  };

  //-------Handle TradeIns delete click
  const handleDeleteClick = (row) => {
    deleteCategoryMargin(currentStore?.companyId, [String(row.id)]);
  };

  //-------Handle add button click
  const handleAddClick = () => {
    setResetSearchCategories(true);
    toggleCustomTradeModal();
    handleSetByMarginChange(SET_BY_MARGIN_ENUMS.TYPE.value);
  };
  const toggleCustomTradeModal = (resetSearch) => {
    setShow(!show);
    setModalCheckBoxStatus(false);
    setSelectedCategories([]);
    if (resetSearch || isEdit || resetSearchCategories) {
      setResetSearchCategories(false);
      setIsEdit(false);
      setEditCategory("");
    }
  };

  const globalHandleSubmit = (data, { resetForm }) => {
    const dataToSend = {
      marginType: MARGIN_TYPES.GLOBAL,
      cashMarginPercentage: data.cashMargin,
      tradeinMarginPercentage: data.tradeMargin,
      store: {
        name: currentStore.storeName,
        id: currentStore.id,
      },
      companyId: currentStore?.companyId,
    };
    addGlobalMargin(currentStore?.companyId, dataToSend);
    resetForm();
  };

  const modalHandleSubmit = (data) => {
    if (selectedCategories?.length <= 0) {
      customToast(
        data.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value
          ? toastMessages.PLEASE_SELECT_PRODUCTS
          : toastMessages.PLEASE_SELECT_CATEGORIES,
        toastType.ERROR
      );
      return;
    }

    let dataToSend = [];
    if (data.setBy === SET_BY_MARGIN_ENUMS.TYPE.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          productType: items.name,
          cashMarginPercentage: data.cashOffer,
          tradeinMarginPercentage: data.tradeOffer,
          minPriceRange: modalCheckBoxStatus
            ? data.minPrice
            : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
          maxPriceRange: modalCheckBoxStatus
            ? data.maxPrice
            : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
        };
        return newObject;
      });
      dataToSend = {
        id: data.id,
        marginType: SET_BY_MARGIN_ENUMS.TYPE.value,
        cashMarginPercentage: data.cashOffer,
        tradeinMarginPercentage: data.tradeOffer,
        minPriceRange: modalCheckBoxStatus
          ? data.minPrice
          : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
        maxPriceRange: modalCheckBoxStatus
          ? data.maxPrice
          : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
        marginGroup: updatedSelectedCategories,
        store: {
          id: currentStore.id,
          name: currentStore.storeName,
        },
        companyId: currentStore?.companyId,
      };
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          categoryId: items.id,
          categoryName: items.name,
        };
        return newObject;
      });
      dataToSend = {
        id: data.id,
        marginType: SET_BY_MARGIN_ENUMS.CATEGORY.value,
        cashMarginPercentage: data.cashOffer,
        tradeinMarginPercentage: data.tradeOffer,
        minPriceRange: modalCheckBoxStatus
          ? data.minPrice
          : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
        maxPriceRange: modalCheckBoxStatus
          ? data.maxPrice
          : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
        marginGroup: updatedSelectedCategories,
        store: {
          id: currentStore.id,
          name: currentStore.storeName,
        },
        companyId: currentStore?.companyId,
      };
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          categoryId: items.id,
          categoryName: items.name,
          parentCategoryId: items.parentCategoryId,
          parentCategoryName: items.parentCategoryName,
        };
        return newObject;
      });
      dataToSend = {
        id: data.id,
        marginType: SET_BY_MARGIN_ENUMS.SUBCATEGORY.value,
        cashMarginPercentage: data.cashOffer,
        tradeinMarginPercentage: data.tradeOffer,
        minPriceRange: modalCheckBoxStatus
          ? data.minPrice
          : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
        maxPriceRange: modalCheckBoxStatus
          ? data.maxPrice
          : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
        marginGroup: updatedSelectedCategories,
        store: {
          id: currentStore.id,
          name: currentStore.storeName,
        },
        companyId: currentStore?.companyId,
      };
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value) {
      const updatedSelectedProducts = selectedCategories.map((item) => ({
        product_id: item.product_id,
        product_name: item.product_name,
        productType: item.productType,
        category_name: item.category_name,
        cardRarity: item.cardRarity,
        subcategory: item.subcategory,
      }));

      dataToSend = {
        id: data.id,
        tags: selectedTags,
        productCondition: selectedCondition?.value,
        marginType: SET_BY_MARGIN_ENUMS.PRODUCT.value,
        cashMarginPercentage: data.cashOffer,
        productMarginSetBy: itemMarginUnit
          ? tradeInDiscountConstant.FIXED_VALUE
          : tradeInDiscountConstant.PERCENTAGE,
        tradeinMarginPercentage: data.tradeOffer,
        minPriceRange: modalCheckBoxStatus
          ? data.minPrice
          : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
        maxPriceRange: modalCheckBoxStatus
          ? data.maxPrice
          : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
        marginGroup: updatedSelectedProducts,
        store: {
          id: currentStore.id,
          name: currentStore.storeName,
        },
        companyId: currentStore?.companyId,
      };
    }

    if (isEdit) {
      updateCategoryMargin(
        currentStore?.companyId,
        dataToSend,
        toggleCustomTradeModal
      );
    } else {
      addCategoryMargin(
        currentStore?.companyId,
        dataToSend,
        toggleCustomTradeModal,
        resetSearch
      );
    }
  };
  const HandleSubmit = (data) => {
    addMonthlyBudget(currentStore?.id, {
      ...data,
      budget: data.budget,
    });
  };

  const columnHeaders = [
    {
      id: "setBy",
      name: "Set By",
      selector: (row) => row.marginType,
      cell: (row) => {
        return (
          <TableCustomCellWrapper
            cellValue={
              SET_BY_TRADE_IN_MARGIN_OPTIONS.find(
                (item) => item.value === row.marginType
              ).label
            }
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "appliesTo",
      name: "Applies To",
      selector: (row) =>  getGroupArrayDisplayText(row.marginGroup, row.marginType),
      cell: (row) => {
        return (
          <TableCustomAppliesToField
            row={row}
            groupArray={row.marginGroup}
            groupType={row.marginType}
          />
        );
      },
      sortable: true,
      sortDirection: null,
    },
    {
      id: "priceRange",
      name: "Price Range",
      selector: (row) => row.maxPriceRange,
      cell: (row) => {
        return <TableCustomPriceRangeField row={row} />;
      },
      sortable: true,
      sortDirection: null,
    },

    {
      id: "cashPercentage",
      name: "Cash Offer",
      selector: (row) => row.cashMarginPercentage,
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={
            row.productMarginSetBy === tradeInDiscountConstant.FIXED_VALUE
              ? `$${row.cashMarginPercentage}`
              : `${row.cashMarginPercentage}%`
          }
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "tradePercentage",
      name: "Trade Offer",
      selector: (row) => row.tradeinMarginPercentage,
      cell: (row) => (
        <TableCustomCellWrapper
          cellValue={
            row.productMarginSetBy === tradeInDiscountConstant.FIXED_VALUE
              ? `$${row.tradeinMarginPercentage}`
              : `${row.tradeinMarginPercentage}%`
          }
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    getActionColumnOfReactDataTableComponent((row) => {
      return (
        <>
          <CustomTooltip anchorSelect={`#tool${row.id}`}>
            <Button
              label={buttonNameConstants.EDIT}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={EditIcon}
              handleClick={() => handleEditClick(row)}
            />
            <Button
              label={buttonNameConstants.DELETE}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={DeleteIcon}
              handleClick={() => handleDeleteClick(row)}
            />
          </CustomTooltip>
          <button id={`tool${row.id}`} className="action-Button-Wrapper">
            <ActionDotsIcons className="cursor-pointer" />
          </button>
        </>
      );
    }),
  ];

  const [columns, setColumns] = useState([]);

  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  const updateGridState = (newGridState) => {
    setGridState(newGridState);
  };

  //-------Handle searchfield change
  const handleFilterData = (e) => {
    const filterList = updatedRowsData.filter((row) => {
      return (
        String(
          row.categoryName +
            row.maxPriceRange +
            row.minPriceRange +
            row.cashMarginPercentage +
            row.tradeinMarginPercentage
        )
          .toLowerCase()
          .includes(String(searchText).toLowerCase()) &&
        searchText !== EMPTY_STRING
      );
    });
    // reset the pagination
    numOfRenders.current++;
    return filterList;
  };

  const handleSelectedTagsChange = (value) => {
    setSelectedTags(value?.map((tag) => tag.label) || []);
  };

  const handleSwitchButtonChange = (data, setFieldValue) => {
    const value =
      !currentStore?.[
        toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
      ];

    setFieldValue(
      [toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS],
      value
    );
    addMonthlyBudget(
      currentStore?.id,
      {
        budget: currentStore?.budget || 0,
        [toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS]:
          value || false,
      },
      false
    );
  };

  useEffect(() => {
    setSearchCategories(
      filterApplyToSearchOptions(
        setByFilter,
        customTypes.filter(
          (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
        ),
        customCategories,
        customSubCategories,
        filterProductType,
        filterProductCategory,
        selectedCategories
      )
    ); // eslint-disable-next-line
  }, [setByFilter, filterProductType, filterProductCategory]);

  useEffect(() => {
    setColumns(columnHeaders);
    // eslint-disable-next-line
  }, [currentStore]);

  useEffect(() => {
    handleSetByMarginChange(SET_BY_MARGIN_ENUMS.TYPE.value);
    // eslint-disable-next-line
  }, [customCategories]);

  useEffect(() => {
    setupdatedRowsData([
      ...(tradeinMargin?.categoryMargins || []),
      ...(tradeinMargin?.subcategoryMargins || []),
      ...(tradeinMargin?.productTypeMargins || []),
      ...(tradeinMargin?.productMargins || []),
    ]);
  }, [tradeinMargin]);

  const clearSearchText = () => {
    setSearchText("");
  };
  const resetSearch = () => {
    setResetSearchCategories(true);
  };

  //-------Return TradeIns Component
  return (
    <>
      <Topbar title="Trade-Ins"></Topbar>
      <Row className="m-0 w-100">
        <Col md={12} className="tradeIns-heading">
          Custom Trade-In Margin
        </Col>
        <Col md={8} className="p-0">
          <Row className="m-0 h-100  user-screen-wrapper w-100 min-vh-100 ">
            <Row className="m-0  p-0 w-100 user-screen-wrapper">
              <Col md={9} className="">
                <SearchField
                  onChange={(e) => setSearchText(e.target.value)}
                  IconImage={SearchIcon}
                  label="Search"
                  placeHolder="Type or Scan"
                  value={searchText}
                  CrossIcon={searchText ? CrossIcon : ""}
                  clearSearchText={clearSearchText}
                  BlueBoxIcon={BlueBoxIcon}
                />
              </Col>
              <Col
                md={3}
                className="d-flex justify-content-end align-items-end gap-3"
              >
                <Button
                  label={buttonNameConstants.ADD}
                  IconImage={AddIcon}
                  handleClick={handleAddClick}
                  className="w-100"
                />
              </Col>
            </Row>
            <Row className="m-0 p-0  w-100 h-100 user-screen-wrapper  pt-3">
              <DataTableComponent
                tableId={TABLE_IDS.SETTINGS_TRADE_INS}
                className="tradeIn-table-height"
                key={numOfRenders.current}
                columns={columns}
                data={searchText ? handleFilterData() : updatedRowsData}
                onSort={onTableSort}
                defaultSortFieldId={defaultSortFieldId}
                gridState={gridState}
                setGridState={updateGridState}
                total={
                  searchText
                    ? handleFilterData()?.length
                    : updatedRowsData?.length
                }
              />
            </Row>
          </Row>
        </Col>
        <Col md={4}>
          <Row className="m-0 user-screen-wrapper container-scrollbar">
            <Col md={12} className="mb-3  p-0">
              <Formik initialValues={initialValues} enableReinitialize>
                {({ values, setFieldValue }) => (
                  <Form className=" d-flex justify-content-between align-items-center global-trade-div">
                    <p className="m-0 text-bold">
                      Always Use Stock Price for COGS
                    </p>
                    <SwitchButton
                      onSwitchChange={() =>
                        handleSwitchButtonChange(values, setFieldValue)
                      }
                      isSwitchOn={
                        values[
                          toggleSwitchButtonConstants
                            .ALWAYS_USE_STOCK_PRICE_FOR_COGS
                        ]
                      }
                      isDisabled={isSpinnerEnabled(
                        spinnerArray,
                        tradeInDiscount.ADD_MONTHLY_BUDGET
                      )}
                    />
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
          <Row className="m-0 user-screen-wrapper container-scrollbar">
            <Formik
              initialValues={initialGlobalValues}
              validate={tradeInsGlobalValidationSchema}
              onSubmit={globalHandleSubmit}
              enableReinitialize
            >
              {({ resetForm }) => (
                <Form className="px-0">
                  <Row className="global-trade-div">
                    <p className="tradeIns-heading p-0">
                      Global Trade-in Margin
                    </p>
                    <Col md={12} className="mb-3  p-0">
                      <InputNumberField
                        className="input-field-background-tradeIns"
                        name="cashMargin"
                        placeHolder="35 %"
                        type="number"
                        label="Cash Margin"
                        maxValue={100}
                        IconImage={PercentageIcon}
                      />
                    </Col>
                    <Col md={12} className="mb-3  p-0">
                      <InputNumberField
                        className="input-field-background-tradeIns"
                        name="tradeMargin"
                        placeHolder="35 %"
                        type="number"
                        label="Trade Margin"
                        maxValue={100}
                        IconImage={PercentageIcon}
                      />
                    </Col>
                    <Col
                      md={12}
                      className="d-flex mt-2 p-0 justify-content-end align-items-center gap-3"
                    >
                      <Button
                        type="button"
                        label={buttonNameConstants.CANCEL}
                        handleClick={() => {
                          // handleCancelButton();
                          resetForm();
                        }}
                        buttonType={buttonTypeConstants.GHOST_BUTTON}
                        className="min-width-btn-trads"
                      ></Button>
                      <Button
                        type="submit"
                        label={buttonNameConstants.SAVE}
                        handleClick={() => {
                          // handleCancelButton();
                        }}
                        buttonType={buttonTypeConstants.LIGHT_PURPLE}
                        className="min-width-btn-trads"
                      ></Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Row>

          <Row className="m-0 mt-3">
            <Formik
              initialValues={initialValues}
              validate={tradeInsMonthlyValidationSchema}
              onSubmit={HandleSubmit}
              enableReinitialize
            >
              {({ resetForm }) => (
                <Form className="px-0">
                  <Row className="global-trade-div">
                    <p className="tradeIns-heading mb-1 p-0">Monthly Budget</p>
                    <p className="monthly-budget-heading p-0">
                      Resets on the first day of the month
                    </p>
                    <Col md={12} className="mb-3  p-0">
                      <InputNumberField
                        className="input-field-background-tradeIns"
                        name="budget"
                        placeHolder="$5,000.00"
                        type="number"
                        IconImage={DollarIcon}
                      />
                    </Col>

                    <Col
                      md={12}
                      className="d-flex mt-2 p-0 justify-content-end align-items-center gap-3"
                    >
                      <Button
                        type="button"
                        label={buttonNameConstants.CANCEL}
                        handleClick={() => {
                          // handleCancelButton();
                          resetForm();
                        }}
                        buttonType={buttonTypeConstants.GHOST_BUTTON}
                        className="min-width-btn-trads"
                      ></Button>
                      <Button
                        type="submit"
                        label={buttonNameConstants.SAVE}
                        handleClick={() => {
                          // handleCancelButton();
                        }}
                        buttonType={buttonTypeConstants.LIGHT_PURPLE}
                        className="min-width-btn-trads"
                      ></Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Row>
        </Col>
      </Row>

      <AddTradeInMargin
        show={show}
        isEdit={isEdit}
        columns={columns}
        setColumns={setColumns}
        productTags={productTags}
        customTypes={customTypes}
        setByFilter={setByFilter}
        selectedTags={selectedTags}
        editCategory={editCategory}
        itemMarginUnit={itemMarginUnit}
        searchCategories={searchCategories}
        categoriesColumn={getTypeCategoryColumns(
          searchCategories,
          setSearchCategories,
          selectedCategories,
          setSelectedCategories
        )}
        customCategories={customCategories}
        setItemMarginUnit={setItemMarginUnit}
        selectedCondition={selectedCondition}
        modalHandleSubmit={modalHandleSubmit}
        filterProductType={filterProductType}
        handleSetByChange={handleSetByMarginChange}
        selectedCategories={selectedCategories}
        handleSwitchChange={handleSwitchChange}
        setSearchCategories={setSearchCategories}
        customSubCategories={customSubCategories}
        modalCheckBoxStatus={modalCheckBoxStatus}
        productConditionList={productConditionList}
        productMarginColumns={getProductMargnColumns(
          searchCategories,
          setSearchCategories,
          selectedCategories,
          setSelectedCategories
        )}
        setSelectedCondition={setSelectedCondition}
        setFilterProductType={setFilterProductType}
        handleCategorySelect={handleCategorySelect}
        setSelectedCategories={setSelectedCategories}
        filterProductCategory={filterProductCategory}
        toggleCustomTradeModal={toggleCustomTradeModal}
        handleSelectedTagsChange={handleSelectedTagsChange}
        setFilterProductCategory={setFilterProductCategory}
        defaultCategorySortFieldId={defaultCategorySortFieldId}
        setDefaultCategorySortFieldId={setDefaultCategorySortFieldId}
      />
    </>
  );
}; //-------TradeIns component end here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  itemOrganization: state.itemOrganization,
  tradeinMargin: state.tradeDiscount.tradeinMargin,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addGlobalMargin: (companyId, data) => {
    dispatch(tradeInDiscountActions.addGlobalMargin(companyId, data));
  },
  addCategoryMargin: (companyId, data, toggleCustomTradeModal, resetSearch) => {
    dispatch(
      tradeInDiscountActions.addCategoryMargin(
        companyId,
        data,
        toggleCustomTradeModal,
        resetSearch
      )
    );
  },
  updateCategoryMargin: (companyId, data, toggleCustomTradeModal) => {
    dispatch(
      tradeInDiscountActions.updateCategoryMargin(
        companyId,
        data,
        toggleCustomTradeModal
      )
    );
  },
  deleteCategoryMargin: (companyId, id) => {
    dispatch(tradeInDiscountActions.deleteCategoryMargin(companyId, id));
  },
  addMonthlyBudget: (storeId, data, isShowToast) => {
    dispatch(
      tradeInDiscountActions.addMonthlyBudget(storeId, data, isShowToast)
    );
  },
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(TradeIns);
